// extracted by mini-css-extract-plugin
export default {"profile":"NC7VWodo5i2UXKKyqUBJ"};